import * as React from "react";

import env from "../utils/env";
import { connect } from "react-redux";
import { User } from "../modules/session/types";
import { Organization } from "../modules/organizations/types";
import { RootState } from "../modules/types";

const PENDO_ENABLED = !(env.DEBUG == "true") || true;
const PENDO_API_KEY = env.PENDO_API_KEY;
const DEPLOYMENT = env.DEPLOYMENT || "-";
const ANONYMOUS_VISITOR_ID = "patient_ANONYMOUS";
const ANONYMOUS_ACCOUNT_ID = "account_ANONYMOUS";

interface StoreProps {
  currentUser: User | null;
  currentOrg: Organization | null;
}

interface OwnProps {
  pendoEnabled: boolean;
  pendoApiKey: string;
  deploymentId: string;
  annonymousAccountId: string;
  annonymousVisitorId: string;
  isAnonymous?: boolean;
  participantType?: string;
}

type Props = StoreProps & OwnProps;

class PendoDataProvider extends React.Component<Props> {
  public getUserPendoData(currentUser?: User, currentOrg?: Organization | null) {
    const {
      annonymousAccountId,
      annonymousVisitorId,
      participantType,
      isAnonymous,
      deploymentId
    } = this.props;
    if (isAnonymous) {
      return {
        visitor: {
          id: participantType ? participantType + "_ANONYMOUS" : annonymousVisitorId
        },
        account: {
          id: annonymousAccountId,
          deployment: deploymentId
        }
      };
    }
    const pendoData = {
      visitor: {
        id: currentUser?.id,
        email: currentUser?.email,
        hasVideoFeature: currentUser?.featureFlags?.enableVideo || false
      },
      account: {
        id: currentOrg?.id || "",
        name: currentOrg?.name || "",
        deployment: deploymentId
      }
    };
    return pendoData;
  }

  public componentDidMount() {
    this.updatePendoInformation();
  }

  public componentDidUpdate() {
    this.updatePendoInformation();
  }

  public updatePendoInformation() {
    const { currentUser, isAnonymous, pendoEnabled, pendoApiKey, currentOrg } = this.props;

    if (pendoEnabled && currentUser && pendoApiKey) {
      // Initialize pendo object on window.
      (window as any).pendo = {
        _q: [["initialize", this.getUserPendoData(currentUser, currentOrg)]]
      };
      this.loadPendo();
    } else if (pendoEnabled && isAnonymous && pendoApiKey) {
      // Initialize pendo object on window.
      (window as any).pendo = {
        _q: [["initialize", this.getUserPendoData()]]
      };
      this.loadPendo();
    }
  }

  public loadPendo = () => {
    const { pendoApiKey } = this.props;
    // Load pendo.js
    const script = document.createElement("script");
    const body = document.getElementsByTagName("body")[0];
    script.src = `https://content.analytics.telmediq.com/agent/static/${pendoApiKey}/pendo.js`;
    script.async = true;
    body.appendChild(script);
  };

  public render() {
    return null;
  }
}

export default connect(
  (state: RootState): Props => ({
    currentUser: state.session.data.currentUser,
    currentOrg: state.orgs.currentOrganization,
    pendoEnabled: PENDO_ENABLED,
    pendoApiKey: PENDO_API_KEY,
    deploymentId: DEPLOYMENT,
    annonymousAccountId: ANONYMOUS_ACCOUNT_ID,
    annonymousVisitorId: ANONYMOUS_VISITOR_ID
  })
)(PendoDataProvider);
